<template>
	<div class="login flex start-v">
		<span class="title">虚拟仿真实训系统</span>
		<div class="form flex between-v">
			<div class="flex start-v">
				<span class="school-name">上海财经大学浙江学院</span>
				<span class="school-name nameb">跑步虚拟仿真实训系统</span>
			</div>
			<img class="icon-sign" src="@img/icon/ui_sign_in.png" alt />

			<form class="flex between-v">
				<div class="name">
					<input v-model="userInfo.account" maxlength="20" type="text" :placeholder="['请输入学号','请输入账号'][$store.state.role]" />
				</div>
				<div class="password">
					<input v-model="userInfo.password" maxlength="20" type="password" placeholder="请输入密码" autocomplete="off" />
				</div>
			</form>

			<span class="tips">
				注：初始密码为：000000
				<br />若忘记密码请联系任课老师进行密码重置
			</span>
		</div>
		<div class="btn">
			<button class="btn-full" @click="login">登录</button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			userInfo: {
				account: "",
				password: "",
			},
		};
	},
	methods: {
		login() {
			let res = this.$store.dispatch("login",this.userInfo);

			// console.log(this.$store);
			// this.$router.push("/home")
		},
	},
};
</script>

<style lang="less" scoped>
.login {
	height: 100vh;
	background-color: #d66123;
	padding: 0 7 / @rem;
	.title {
		font-size: 16 / @rem;
		color: #fffacc;
		margin-top: 30/@rem;

	}
	.form {
		width: 100%;
		min-height: 465 / @rem;
		margin: 22 / @rem auto 27 / @rem;
		padding: 35 / @rem 0 33 / @rem;
		background-image: url(~@img/bg.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		border-radius: 7 / @rem;
		overflow: hidden;
		img.icon-sign {
			width: 94 / @rem;
			height: 94 / @rem;
			object-fit: contain;
			margin-top: 6 / @rem;
		}
		span.tips {
			color: white;
			font-size: 15 / @rem;
		}
		input {
			width: 270 / @rem;
			height: 34 / @rem;
			padding-left: 35 / @rem;
			font-size: 15 / @rem;
			color: rgba(49, 49, 49, 0.5);
			border-radius: 1 / @rem;
		}
		input::placeholder {
			// letter-spacing: 6 / @rem;
			letter-spacing: 1/@rem;
			color: rgba(49, 49, 49, 0.5);
		}
		.school-name {
			color: #fffacc;
			font-size: 30 / @rem;
			font-weight: bold;
			letter-spacing: 3 / @rem;
			font-family: Source Han Sans CN-Regular, Source Han Sans CN;
			&.nameb {
				font-weight: 400;
				font-size: 21 / @rem;
				letter-spacing: 1 / @rem;
				padding-top: 12 / @rem;
			}
		}
		form {
			height: 90 / @rem;
		}
		.name,
		.password {
			position: relative;
			background-color: white;
			&::before {
				content: "";
				position: absolute;
				width: 34 / @rem;
				height: 100%;
				left: 0;
				top: 0;
			}
		}
		.name {
			&::before {
				background-image: url(~@img/icon/ui_password.png);
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
		}
		.password {
			&::before {
				background-image: url(~@img/icon/ui_number.png);
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
		}
	}
	.btn {
		width: 100%;
		padding: 0 9 / @rem;
		.btn-full {
			margin-bottom: 42 / @rem;
		}
	}
}
</style>